<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">先生編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'teacher-id-detail', params: { id } }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_teacher.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">ブランド名（ブランドID）</th>
                <td />
                <td>{{ currentBrandDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">先生ID</th>
                <td />
                <td>{{ currentTeacher.uid }}</td>
              </tr>
              <TextField v-model="currentTeacher.name" extraRules="required" label="先生名" />
              <TextField
                v-model="currentTeacher.nameReading"
                extraRules="required"
                label="先生名（フリガナ）"
                placeholder="全角カタカナ"
              />
              <tr>
                <th scope="row" width="25%">生年月</th>
                <td width="10%">
                  <span class="bg-red">必須</span>
                </td>
                <td class="form-inline no-margin-top">
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentTeacher.yearOfBirth"
                      placeholder="選択してください"
                      class="form-control select-year"
                      :class="classes"
                      :clearable="false"
                      :options="previousYears"
                    />
                    <span class="select-text">年</span>
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentTeacher.monthOfBirth"
                      placeholder="選択してください"
                      class="form-control select-month"
                      :class="classes"
                      :clearable="false"
                      :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                    />
                    <span class="select-text">月</span>
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
              </tr>
              <SelectField
                label="性別"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="genders"
                optionValue="id"
                optionLabel="name"
                v-model="currentTeacher.gender.id"
              />
              <SelectField
                label="国籍"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="countries"
                optionValue="id"
                optionLabel="companyjp"
                v-model="currentTeacher.nationality.id"
              />
              <SelectField
                label="雇用形態"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="employmentStatuses"
                optionValue="id"
                optionLabel="name"
                v-model="currentTeacher.employmentStatus.id"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import TextField from '@/components/forms/TextField.vue';
import SelectField from '@/components/forms/SelectField.vue';
import store from '@/store/index.js';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';
import { yearsFrom } from '@/utils/year_helpers';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    TextField,
    SelectField,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('teacher/fetchTeacher', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  computed: {
    currentTeacher() {
      if (this.teacher.editingTeacher) {
        return this.teacher.editingTeacher;
      } else {
        return this.teacher.teacher;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTeacher.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTeacher.brand);
    },
    previousYears() {
      return yearsFrom(1940);
    },
    ...mapState(['teacher']),
    ...mapState({
      countries: (state) => state.country.countries,
      genders: (state) => state.gender.genders,
      employmentStatuses: (state) => state.employment_status.employmentStatuses,
    }),
  },
  methods: {
    confirmEdited() {
      this.$logger.debug('Started Editing: ' + JSON.stringify(this.currentTeacher));
      this.startEditingTeacher(this.currentTeacher);
      this.$router.push({ name: 'teacher-id-confirm', params: { id: this.id } });
    },
    ...mapActions('teacher', ['startEditingTeacher']),
  },
};
</script>

<style lang="scss" scoped>
.btn-confirm {
  margin-left: 0px;
}
/deep/ .v-select-birth {
  .select-month,
  .select-year {
    padding: 0px 2px 0px 10px;
    max-width: initial;
    margin-right: 10px;
    .vs__dropdown-toggle {
      width: 146px;
    }
  }
  .select-text {
    margin-right: 35px;
  }
}
</style>
